import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "../../layouts/Header";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import "../../assets/styles/local/OrderPickingList.css";
import "../../assets/styles/local/asc_Custom_Select_Box.css";
import upArrow from "../../assets/icons/upArrow.png";
import Pagination from "../../components/Pagination/Pagination";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import {
  AddReturnToWarehouse,
  FetchOrderPickingProduct,
  emptyProductBySupplier,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { ADD_RETURN_TO_WAREHOUSE } from "../../redux/constants/type";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import Xicon from "../../assets/icons/Xicon.svg";
import simpleRequest from "../../utils/helpers/simpleRequest";

const ReturnToWarehouseList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const Sortby_Popup_Ref = useRef(null);
  const type_project_Drop_Ref = useRef(null);
  const [projectSearchPeople, setProjectSearchPeople] = useState("");
  const [showProjectsPeople, setShowProjectsPeople] = useState(false);
  const [projectsData, setProjectsData] = useState([]);
  const [projectId, setProjectId] = useState("");

  const [cancelPopupShow, setCancelPopupShow] = useState(false);

  const returnToWarehouseRes = useSelector(
    (state) => state.user.addReturnToWarehouseRes,
  );

  const fetchOrderPickingListRes = useSelector(
    (state) => state.user.fetchOrderPickingProductDropdown,
  );

  const handleClose = () => setCancelPopupShow(false);

  const handleCancel = (e) => {
    history.goBack();
  };

  const [typeInScreen, setTypeInScreen] = useState("");
  const [querystring, setQuerystring] = useState("");
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  const [listData, setListData] = useState([]);
  const [single, setSingle] = useState(false);
  const [list, setList] = useState(true);
  const [listHover, setListHover] = useState(false);
  const [asc_ProductPartid, setAsc_ProductPartid] = useState("");
  const [asc_Itemdescription, setAsc_Itemdescription] = useState("");

  // for sort by
  const [shortByArrow, setShortByArrow] = useState(true);
  const [showShortDrop, setShowShortDrop] = useState(false);
  const [sortedValue, setSortedValue] = useState("itemid");
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const sortedPayload = shortByArrow
      ? `${sortedValue}-asc`
      : `${sortedValue}-desc`;
    if (projectId) dispatch(FetchOrderPickingProduct(sortedPayload, projectId));
  }, [
    dispatch,
    shortByArrow,
    sortedValue,
    returnToWarehouseRes?.status,
    projectId,
  ]);

  useEffect(() => {
    fetchScreenTranslations("Return to Warehouse").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    if (fetchOrderPickingListRes?.status) {
      let data = fetchOrderPickingListRes.data;
      data = data.map((x) => {
        return {
          ...x,
          // qtyToPick: x.supplier?.[0]?.qtytoPick ?? 0,
          // newQtyToPick: x.supplier?.[0]?.qtytoPick ?? 0,
          qtyToPick: x?.qtytoPick ?? 0,
          newQtyToPick: x?.qtytoPick ?? 0,
          isCheck: false,
        };
      });
      setListData(data);
      setTotalPages(Math.ceil(fetchOrderPickingListRes.data.length / perPage));
    }
  }, [fetchOrderPickingListRes, perPage]);

  useEffect(() => {
    if (returnToWarehouseRes?.status) {
      setListData([]);

      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: ` Great Job! The product was return.`,
        },
        false,
      );
      dispatch({
        type: ADD_RETURN_TO_WAREHOUSE,
        data: {},
      });
    } else if (returnToWarehouseRes?.status === false) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: `something went wrong!`,
        },
        false,
      );
      dispatch({
        type: ADD_RETURN_TO_WAREHOUSE,
        data: {},
      });
    }
  }, [returnToWarehouseRes?.status, dispatch]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      Sortby_Popup_Ref.current &&
      !Sortby_Popup_Ref.current.contains(event.target)
    ) {
      setShowShortDrop(false);
    }
    if (
      type_project_Drop_Ref.current &&
      !type_project_Drop_Ref.current.contains(event.target)
    ) {
      setShowProjectsPeople(false);
    }
  };

  const handleOrderPicking = () => {
    if (
      listData
        .filter((x) => x.isCheck)
        .some(
          (item) =>
            item.newQtyToPick > item.instock ||
            item.newQtyToPick > item.qtyToPick ||
            item.newQtyToPick === 0 ||
            item.qtyToPick === 0,
        )
    ) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: `Please adjust qty to pick according to a stock`,
        },
        false,
      );
      return;
    }
    if (!projectId)
      return handleGeneralNotification({
        notificationType: "CUSTOM",
        text: `Please select a project!`,
      });
    if (listData?.length > 0) {
      let payload = {
        returnToWarehouseqty: listData
          .filter((x) => x.isCheck && x.newQtyToPick > 0)
          .map((x) => ({
            orderproductid: x.orderproductid,
            productcode: x.productPartCode,
            productqty: x.newQtyToPick.toString(),
          })),
      };

      dispatch(AddReturnToWarehouse(payload));
    }
  };

  const sortByOption = [
    // { label: "Item Name", value: "itemname" },
    // { label: "Item ID", value: "itemid" },
    // { label: "Aisle", value: "aisl" },
    // { label: "Row", value: "row" },
    // { label: "Bin", value: "bin" },

    { label: t("Item Name"), value: "itemname" },
    { label: t("Item ID"), value: "itemid" },
    { label: t("Aisle"), value: "aisl" },
    { label: t("Row"), value: "row" },
    { label: t("Bin"), value: "bin" },
  ];

  document.getElementById("asc_input")?.focus();

  // asc for disable Add Button start.
  let disableData = listData.some((x) => x.isCheck);
  // asc for disable Add Button end.

  const [notificationTriggered, setNotificationTriggered] = useState(false);

  const handleQtyToPickChange = (e, item) => {
    e.preventDefault();
    const { value } = e.target;
    const newValue = Number(value);
    if (newValue > item.instock || newValue > item.qtyToPick) {
      if (!notificationTriggered) {
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: `You can't return more than stock quantity and ReturnToPick ${item.qtyToPick}`,
          },
          false,
        );
        setNotificationTriggered(true);
        setTimeout(() => {
          setNotificationTriggered(false);
        }, 500);
      }
      return;
    }

    let data = [...listData];
    let productIndex = data.findIndex(
      (arg) => arg.productPartCode === item.productPartCode,
    );
    data[productIndex]["newQtyToPick"] = newValue;
    data[productIndex]["isCheck"] = true;
    setListData(data);
  };

  const fetchProjects = async () => {
    const resp = await simpleRequest(`/api/User/ProjectDropdown`, "post", {});
    if (resp.status === true) setProjectsData(resp.data);
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  return (
    <mainSection>
      <Header
        setQuery={setQuerystring}
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <p className="products-and-parts-sub-title">
              {/* Return to Warehouse */}
              {t("Return to Warehouse")}
            </p>

            <div className="d-flex mainSwitch ms-5 pointer">
              <div
                className={
                  single ? "singleSwitch px-4 py-1" : "noSwitch px-4 py-1"
                }
                onClick={() => {
                  setSingle(true);
                  setList(false);
                  history.replace("/return-to-warehouse-single");
                  dispatch(emptyProductBySupplier());
                }}
              >
                {/* Single */}
                {t("Single")}
              </div>
              <div
                className={list ? "listSwitch px-4 py-1" : "noSwitch px-4 py-1"}
                onClick={() => {
                  setList(true);
                  setSingle(false);
                  history.replace("/return-to-warehouse-list");
                  dispatch(emptyProductBySupplier());
                }}
              >
                {/* List */}
                {t("List")}
              </div>
            </div>
          </div>
        }
      />

      {cancelPopupShow && (
        <CancelWarningModal
          show={cancelPopupShow}
          // onHide={() => setCancelPopupShow(false)}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={typeInScreen !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          // if (typeInScreen !== "") {
          //   if (
          //     !["/stock"].includes(location.pathname)
          //   ) {
          //     return true;
          //   }
          // }
          return false;
        }}
      />

      <headerSection>
        <div className="ps-5 d-flex gap-4 flex-wrap">
          <sortSection
            className="d-flex gap-3 w- pt-3"
            style={{ position: "relative" }}
            ref={Sortby_Popup_Ref}
          >
            <p className="sortBy">
              {/* Sort by */}
              {t("Sort by")}
            </p>
            <img
              className={
                shortByArrow
                  ? "downSortArrow mt-1 pointer"
                  : "upSortArrow mt-1 pointer"
              }
              src={upArrow}
              alt=""
              onClick={() => setShortByArrow(!shortByArrow)}
            />
            <p
              className="datetext pointer"
              onClick={() => setShowShortDrop(!showShortDrop)}
            >
              {sortByOption.find((option) => option.value === sortedValue)
                ?.label || "Select"}
            </p>

            <div
              className="sortDropDiv p-3"
              style={{
                transform: showShortDrop ? "scale(1)" : "scale(0)",
                transitionDuration: "300ms",
                width: "95%",
              }}
            >
              {sortByOption.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={
                      sortedValue === item.value
                        ? "datetext pointer"
                        : "pointer"
                    }
                    onClick={() => {
                      setSortedValue(item.value);
                      setShowShortDrop(false);
                    }}
                  >
                    <p className="d-flex gap-">
                      {item.label}
                      {sortedValue === item.value && (
                        <p className="mb-0 ps-3">✓</p>
                      )}{" "}
                    </p>
                  </div>
                );
              })}
            </div>
          </sortSection>

          <div className="ms-auto me-1 me-sm-5 d-flex flex-wrap gap-3 pt-2 threeButtons">
            <button
              className="mb-0 cancelBtn"
              onClick={() => {
                if (typeInScreen !== "") {
                  setCancelPopupShow(true);
                } else {
                  history.replace("/stock");
                }
              }}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>

            <button
              className="mb-0 makeInvoBtn"
              style={{
                cursor: disableData === false ? "not-allowed" : "pointer",
              }}
              disabled={disableData === false}
              onClick={() => {
                handleOrderPicking();
              }}
            >
              {/* Return */}
              {t("Return")}
            </button>
          </div>
        </div>
      </headerSection>
      <div className="ps-5" style={{ paddingRight: "3rem", maxWidth: "500px" }}>
        <div
          className="asc-input-container"
          id="ascInput"
          style={{
            border: "0.5px solid #70707080",
            borderRadius: "6px",
            marginBottom: "1rem",
            background: "white",
          }}
          ref={type_project_Drop_Ref}
        >
          <label
            className="asc-label-top ClientNameText"
            style={{ background: "#fff" }}
          >
            Project
          </label>
          <input
            type="text"
            className="typeSupplier asc_NormalInput ps-3"
            style={{
              fontSize: "14px",
              fontWeight: "700",
              color: "#323232",
              width: "90%",
              border: "unset",
              background: "white",
            }}
            placeholder={t("Type a project")}
            // placeholder={FetchTranslationList[14]?.translation}
            value={projectSearchPeople}
            onChange={(e) => {
              setProjectSearchPeople(e.target.value);
              setShowProjectsPeople(true);
            }}
            onFocus={() => {
              setShowProjectsPeople(true);
              setProjectSearchPeople("");
              setProjectId("");
            }}
          />
          <img
            src={Xicon}
            className={
              projectSearchPeople || showProjectsPeople
                ? "purch_xicon pointer mx-2"
                : "purch_xicon mx-2 invisible"
            }
            alt=""
            onClick={() => {
              setProjectSearchPeople("");
              setShowProjectsPeople(!showProjectsPeople);
              setProjectId("");
            }}
          />
          {showProjectsPeople && (
            <div
              className="customSelect_Outer_purch"
              style={{ height: "unset", zIndex: 10 }}
            >
              <div className="asc_Search_List ps-0" id="ascSelectBox">
                {projectsData
                  ?.filter(
                    (item) =>
                      item.projectname
                        ?.toLowerCase()
                        .includes(projectSearchPeople.toLowerCase()) ||
                      item.projectcode
                        ?.toLowerCase()
                        .includes(projectSearchPeople.toLowerCase()),
                    // item.lastname?.toLowerCase().includes(projectSearchPeople)
                  )
                  .map((people, index) => {
                    let existItem = false;
                    if (projectId === people.projectid) {
                      existItem = true;
                    }
                    return (
                      <div
                        key={index}
                        style={{
                          backgroundColor: existItem ? "#d8d8e5" : "",
                        }}
                        className="dropDown_peoples_flex ulterDrop w-100 m-0"
                        onClick={() => {
                          // setProjectSearchPeople(people.projectname);
                          setProjectSearchPeople(
                            `${people.projectcode} ┃ ${people.projectname}`,
                          );
                          setProjectId(people.projectid);
                          setShowProjectsPeople(false);
                        }}
                      >
                        <p className="dropDownPeoples_purch">
                          {people?.projectcode}
                          &nbsp;┃&nbsp;
                          {people?.projectname}
                        </p>
                      </div>
                    );
                  })}
                {projectsData.length === 0 && (
                  <span>
                    {/* No projects to display! */}
                    {t("Asset")}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <tableSection>
        <section className="pt-3">
          <div
            className="ascTableWrapper pt-3 mx-5"
            style={{ borderRadius: "15px" }}
          >
            <table className="table">
              <thead>
                <tr
                  className="tableHeading-NewInvoice"
                  style={{
                    borderBottom: "0.5px solid #a5a5a569",
                    top: "-16px",
                    zIndex: "9",
                  }}
                >
                  <th className="ps-5" style={{ width: "35%" }}>
                    {/* Item Name */}
                    {t("Item Name")}
                  </th>
                  <th style={{ width: "15%" }}>
                    {/* Item ID */}
                    {t("Item ID")}
                  </th>
                  <th style={{ width: "15%" }}>
                    {/* Kg */}
                    {t("Kg")}
                  </th>
                  <th style={{ width: "15%" }}>
                    In Stock
                    {/* {FetchTranslationList[20]?.translation} */}
                  </th>
                  {/* <th style={{ width: "10%" }}>
                    {FetchTranslationList[31]?.translation}
                  </th>
                  <th style={{ width: "10%" }}>
                    {FetchTranslationList[32]?.translation}
                  </th>
                  <th style={{ width: "10%" }}>
                    {FetchTranslationList[33]?.translation}
                  </th> */}
                  <th className="text-end pe-4">
                    {/* Qty to Return */}
                    {t("Qty to Return")}
                  </th>
                </tr>
              </thead>

              <tbody
                className="tabLine"
                style={{ borderTop: "none", background: "white" }}
              >
                {listData
                  // .slice(currentPage * perPage, (currentPage + 1) * perPage)
                  ?.filter(
                    (item) =>
                      item.productPartCode
                        ?.toLowerCase()
                        .includes(querystring.toLowerCase()) ||
                      item.productPartName
                        ?.toLowerCase()
                        .includes(querystring.toLowerCase()) ||
                      item.productPartName
                        ?.toLowerCase()
                        .includes(querystring.toLowerCase()) ||
                      item.productPartDescription
                        ?.toLowerCase()
                        .includes(querystring.toLowerCase()) ||
                      // supplier name and item id searching
                      item.supplier?.some(
                        (supplier) =>
                          supplier.productpartcode
                            ?.toLowerCase()
                            .includes(querystring.toLowerCase()) ||
                          supplier.itemid
                            ?.toLowerCase()
                            .includes(querystring.toLowerCase()),
                      ),
                  )
                  ?.map((item, index) => {
                    return (
                      <tr
                        style={{ borderColor: "#e8e0e0" }}
                        key={index}
                        className="TableRowClass bg-transparent"
                      >
                        <td className="ps-5">
                          <div
                            className="d-flex gap-1"
                            style={{ position: "relative" }}
                          >
                            <input
                              class="form-check-input pointer"
                              type="checkbox"
                              id="ascInvoice"
                              checked={item?.isCheck ? true : false}
                              onClick={(e) => {
                                let data = [...listData];
                                let productIndex = data.findIndex(
                                  (arg) =>
                                    arg.productPartid === item.productPartid,
                                );
                                data[productIndex]["isCheck"] =
                                  e.target.checked;
                                setListData(data);
                              }}
                            />
                            <textHoverSection>
                              {listHover &&
                                asc_ProductPartid === item?.productPartid &&
                                item?.productPartName?.length > 30 && (
                                  <div className="textHoverSection">
                                    <h6>
                                      {item?.productPartName?.length > 30 &&
                                        asc_Itemdescription}
                                    </h6>
                                  </div>
                                )}
                            </textHoverSection>
                            <p
                              onMouseEnter={() => {
                                setListHover(true);
                                setAsc_ProductPartid(item?.productPartid);
                                setAsc_Itemdescription(item?.productPartName);
                              }}
                              onMouseLeave={() => {
                                setListHover(false);
                                setAsc_ProductPartid("");
                                setAsc_Itemdescription("");
                              }}
                            >
                              {item?.productPartName?.length > 30
                                ? item?.productPartName?.slice(0, 30) + "..."
                                : item?.productPartName}
                            </p>
                          </div>
                        </td>
                        <td>{item.productPartCode}</td>
                        <td>{item.kg ?? "-"}</td>
                        <td>{item.instock}</td>
                        {/* <td>{item.aisle}</td>
                        <td>{item.row}</td>
                        <td>{item.bin}</td> */}
                        <td
                          className="text-end pe-4"
                          style={{
                            background: "#FAFAFA",
                          }}
                        >
                          <input
                            className={
                              item.isCheck
                                ? "highlightedInput text-end"
                                : "orderPickInput text-end"
                            }
                            type="number"
                            min={0}
                            value={+item?.newQtyToPick ?? +item?.qtyToPick ?? 0}
                            onChange={(e) => handleQtyToPickChange(e, item)}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          {/* {listData.length > 0 && (
            <div className="mx-5">
              <Pagination
                perPage={perPage}
                setPerPage={setPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
              />
            </div>
          )} */}
        </section>
      </tableSection>
    </mainSection>
  );
};

export default ReturnToWarehouseList;
